import {
  container,
  grayColor,
  title,
  coloredShadow,
  whiteColor,
  hexToRgb,
  mrAuto,
  mlAuto,
} from '../../../coscef';

import imageStyles from '../../imagesStyles';

const sectionServiciosStyle = {
  mrAuto,
  mlAuto,
  section: {
    padding: '50px 0',
  },
  container,
  title: {
    ...title,
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
  },
  description: {
    color: grayColor[3],
  },
  cardCategorySocialWhite: {
    marginTop: '10px',
    color: 'rgba(' + hexToRgb(whiteColor) + ', 0.8)',
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      fontSize: '22px',
      position: 'relative',
      marginTop: '-4px',
      top: '2px',
      marginRight: '5px',
    },
    '& svg': {
      position: 'relative',
      top: '5px',
    },
  },
  cardTitleWhite: {
    '&, & a': {
      ...title,
      marginTop: '.625rem',
      marginBottom: '0',
      minHeight: 'auto',
      color: whiteColor + ' !important',
    },
  },
  cardDescriptionWhite: {
    color: 'rgba(' + hexToRgb(whiteColor) + ', 0.8)',
  },
  stats: {
    color: grayColor[0],
    display: 'flex',
    '& .fab,& .fas,& .far,& .fal,& .material-icons': {
      position: 'relative',
      top: '3px',
      marginRight: '3px',
      marginLeft: '3px',
      fontSize: '18px',
      lineHeight: '18px',
    },
    '& svg': {
      position: 'relative',
      top: '3px',
      marginRight: '3px',
      marginLeft: '3px',
      width: '18px',
      height: '18px',
    },
  },
  justifyContentCenter: {
    WebkitBoxPack: 'center !important',
    MsFlexPack: 'center !important',
    justifyContent: 'center !important',
  },
  imgContainer: {
    width: '60%',
    marginLeft: '120px',
    zIndex: '-2',
  },
  img: {
    width: '100%',
    verticalAlign: 'top',
  },
  textCenter: {
    textAlign: 'center',
  },
  marginTop10: {
    marginTop: '10px',
  },
  marginTop50: {
    marginTop: '50px',
  },
  move: {
    marginTop: '60px',
  },
  imgCenter: {
    marginRight: 'auto',
    marginLeft: 'auto',
    // marginLeft: 'auto !important',
  },

  ...imageStyles,
  ...coloredShadow,
};

export default sectionServiciosStyle;
